import React from 'react'
import cssModules from 'react-css-modules'
import PropTypes from 'prop-types'
import styles from './chip_in_complete.less'
import { getI18n } from 'client/i18n'
import { formatMoney } from 'client/griffin'
import { Link } from 'react-router'
import { locationShape } from 'react-router/lib/PropTypes'
import { glimpselessRoute } from 'lib/route_utils'
import StandardError from 'components/common/standard_error'

const i18n = getI18n('components/chip_in_glimpse/chip_in_complete')

class ChipInComplete extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    amount: PropTypes.number,
    currency: PropTypes.string,
    location: locationShape.isRequired,
    error: PropTypes.object,
  }

  render() {
    return (
      <div>
        {this.props.error ? (
          <StandardError
            key="review_error"
            iconType="error"
            title={i18n('error_title')}
            subtitle={i18n('error_subtitle')}
            backButton={true}
          />
        ) : (
          <div>
            <span
              className="icon icon-large icon-circled-checkmark-large"
              styleName="success-indicator"
            />
            <div styleName="title">
              {i18n('you_chipped_in', {
                title: this.props.title,
                amount: formatMoney(this.props.currency, this.props.amount),
              })}
            </div>
            <Link
              to={glimpselessRoute('chip_in')}
              className="vx_btn vx_btn-block"
              styleName="done-button"
            >
              {i18n('done')}
            </Link>
          </div>
        )}
      </div>
    )
  }
}

export default cssModules(ChipInComplete, styles)
